import { render, staticRenderFns } from "./ListNotificationPanel.vue?vue&type=template&id=6e308100"
import script from "./ListNotificationPanel.vue?vue&type=script&lang=js"
export * from "./ListNotificationPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports